import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6c2a5c30&scoped=true"
import script from "./ctrl.js?vue&type=script&lang=js&external"
export * from "./ctrl.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=6c2a5c30&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=6c2a5c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a5c30",
  null
  
)

export default component.exports